import React, { useState, useEffect, useRef } from "react";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";

import "./index.scss";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { formatDate } from "../../utils/commonFunctions";

type AppProps = {
  data?: any;
  startDate: string;
  endDate: string;
  calenderDateGap: null | number;
};

const billableTypeStyle = () => {
  return {
    padding: "4px 12px",
    color: "#407EEE",
    background: "#E5EEFE",
    borderRadius: "16px",
    width: "fit-content",
    // width: "20px",
  };
};

const nonBillableTypeStyle = () => {
  return {
    padding: "4px 12px",
    color: "#744bd1",
    background: "#ede6fc",
    borderRadius: "16px",
    width: "fit-content",
    // width: "20px",
  };
};

const TimeSheetCalender = ({
  data,
  startDate,
  endDate,
  calenderDateGap,
}: AppProps) => {
  const [mode, setMode] = useState("AllWeek");
  const [currentEsstimate, setCurrentEsstimate] = useState<any>([]);
  const [resources, setResources] = useState<any>([]); //left calander
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const calendarRef = useRef<any>(null);
  const [calenderHerderSum, setCalenderHerderSum] = useState<any>([]);
  const [finalReport, setFinalReport] = useState<any>([]);
  
  useEffect(() => {
    if (data?.length > 0) {
      let events = data?.map((ele: any, index: number) => {
        const totalHours = ele?.calendar_data?.reduce(
          (accumulator: any, currentValue: any) =>
            accumulator +
            (currentValue?.time_difference
              ? +currentValue?.time_difference
              : 0),
          0
        );
        return {
          id: ele?.job?.code + ele?.activity_code,
          name:
            (ele?.job?.code ? `${ele?.job?.code}_` : "") +
            (ele?.job?.job_name ? `${ele?.job?.job_name}_` : "") +
            (ele?.period_ended ? `${formatDate(ele?.period_ended)}` : ""),
          activityCode: ele?.activity_code,
          clientName: `${
            ele?.client_details?.company_name
              ? ele?.client_details?.company_name
              : "--/--"
          } ${
            ele?.client_details?.client_code
              ? `(${ele?.client_details?.client_code})`
              : ""
          }`,
          sharedJob: ele?.shared_job ? ele?.shared_job : "",
          hours: totalHours?.toString()?.includes(".")
            ? +totalHours?.toFixed(2)
            : totalHours
            ? +totalHours
            : 0,
        };
      });

      if (events?.length) {
        setResources([
          {
            id: 0,
            name: "TOTAL HOURS",
          },
          ...events,
        ]);
      }
    }
  }, [data]);

  // approved all data

  useEffect(() => {
    if (data?.length > 0) {
      let events = data
        ?.map((ele: any, index: number) => {
          return ele?.calendar_data?.map((data: any, index: number) => {
            return {
              resourceId: data?.job_code + data?.activity_code,
              campaignId: data?.job_code + data?.activity_code,
              name: data?.time_difference?.toFixed(2),
              start: new Date(data?.date),
              end: new Date(data?.date),
              allDay: true,
            };
          });
        })
        .flat();

      setCurrentEsstimate([...events]);
    }
  }, [data, data?.calendar_data]);

  
  // generated from AI
  useEffect(() => {
    if (!startDate || !endDate) return;

    const arr: any = [];
    const totalMap: Record<string, number> = {};

    currentEsstimate?.forEach((el: any) => {
      const date = new Date(el?.start);
      const key = date.toISOString().split("T")[0];
      const hours = parseFloat(el?.name) || 0;

      if (el.resourceId === 0) return; // Skip if already total

      if (totalMap[key]) {
        totalMap[key] += hours;
      } else {
        totalMap[key] = hours;
      }
    });

    // fill all dates from startDate to endDate
    const paddedTotalRow: any[] = [];
    const start = new Date(startDate);
    const end = new Date(endDate);

    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      const key = d.toISOString().split("T")[0];
      const hours = totalMap[key] ?? 0;

      paddedTotalRow.push({
        resourceId: 0,
        campaignId: 0,
        name: +hours.toFixed(2),
        start: new Date(key),
        end: new Date(key),
        allDay: true,
      });
    }

    setCalenderHerderSum(paddedTotalRow);
    setFinalReport([...paddedTotalRow, ...currentEsstimate]);
  }, [currentEsstimate, startDate, endDate]);

  const computeDurations = (mode: any) => {
    switch (mode) {
      case "AllWeek":
        let finalResult: any = {
          slotDuration: { days: 1 },
          slotLabelFormat: [{ month: "long" }, { day: "2-digit" }],
          duration: { days: 366 },
        };
        return finalResult;

      default:
        return {};
    }
  };

  const CampaignResource = ({ resource }: any) => {
    const { name, activityCode, clientName, sharedJob, hours } =
      resource.extendedProps;
    let finalName =
      name && name !== "undefined" ? name.slice(0, 15) + "..." : "";
    let finalClientName =
      clientName && clientName !== "undefined"
        ? clientName.slice(0, 15) + "..."
        : "";
    let finalActivityCode =
      activityCode && activityCode !== "undefined"
        ? activityCode.slice(0, 10) + "..."
        : "";

    return (
      <>
        {name || name === "" ? (
          <td
            className="job-id"
            style={{
              color: activityCode === "&" ? "transparent" : "#262a44",
              fontSize: "14px",
              fontWeight: "500",
              width: "300px",
              background:
                name === "Employee Schedule" || name === "Total Hours Allocated"
                  ? "rgba(191, 203, 225, 0.6)"
                  : name == "TOTAL HOURS"
                  ? "#e8ecf0"
                  : "white",
              display: "flex",
              justifyContent: "flex-start",
              height: "61px",
            }}
          >
            {activityCode?.length < 20 ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    flexDirection: "column",
                  }}
                >
                  <span className="ml-2">{activityCode}</span>
                  {/* //for future use */}
                  {/* <div
                className="ml-2"
                    style={
                            !clientName?.includes("--/--")
                              ? billableTypeStyle()
                              :  nonBillableTypeStyle()
                          }
                        >
                       
                          {!clientName?.includes("--/--")
                            ? "Billable": "Non Billable"}
            </div> */}
                </div>
              </>
            ) : (
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 250 }}
                overlay={
                  <Tooltip id="button-view-open-item">{activityCode}</Tooltip>
                }
              >
                <>
                  <span className="ml-2">{finalActivityCode}</span>
                  {/* //for future use */}
                  {/* <div
                  className="ml-2"
                    style={
                            !clientName?.includes("--/--")
                              ? billableTypeStyle()
                              :  nonBillableTypeStyle()
                          }
                        >
                       
                          {!clientName?.includes("--/--")
                            ? "Billable": "Non Billable"}
                        </div> */}
                </>
              </OverlayTrigger>
            )}
          </td>
        ) : (
          ""
        )}
        <td
          className="job-id"
          style={{
            color: "#262a44",
            fontSize: "14px",
            fontWeight: "500",
            background:
              name == "Employee Schedule" || name == "Total Hours Allocated"
                ? "rgba(191, 203, 225, 0.6)"
                : name == "TOTAL HOURS"
                ? "#e8ecf0"
                : "white",
            width: "350px",
            wordWrap: "break-word",
            display: "flex",
            justifyContent: "left",
            height: "61px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "3px",
              paddingLeft: "5px",
            }}
          >
            {name === "Total Hours Allocated" &&
            activityCode &&
            activityCode !== "undefined" ? (
              <span style={{ width: "100%" }} className="ml-2">
                {name}
              </span>
            ) : name?.length < 15 ? (
              <>
                <span className="ml-2" style={{ width: "100%" }}>
                  {name != "TOTAL HOURS" ? name : ""}
                  <br></br>
                </span>
                {clientName?.length < 15 ? (
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#6e7491",
                      whiteSpace: "break-spaces",
                    }}
                    className="ml-2"
                  >
                    {clientName}
                  </span>
                ) : (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 250 }}
                    overlay={
                      <Tooltip id="button-view-open-item">{clientName}</Tooltip>
                    }
                  >
                    <span
                      style={{ width: "100%", color: "#6e7491" }}
                      className="ml-2"
                    >
                      {finalClientName}
                      <br></br>
                    </span>
                  </OverlayTrigger>
                )}
              </>
            ) : (
              <>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 250 }}
                  overlay={<Tooltip id="button-view-open-item">{name}</Tooltip>}
                >
                  <span style={{ width: "100%" }} className="ml-2">
                    {finalName}
                    <br></br>
                  </span>
                </OverlayTrigger>

                {clientName?.length < 15 ? (
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#6e7491",
                      whiteSpace: "break-spaces",
                    }}
                    className="ml-2"
                  >
                    {clientName}
                  </span>
                ) : (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 250 }}
                    overlay={
                      <Tooltip id="button-view-open-item">{clientName}</Tooltip>
                    }
                  >
                    <span
                      style={{ width: "100%", color: "#6e7491" }}
                      className="ml-2"
                    >
                      {finalClientName}
                      <br></br>
                    </span>
                  </OverlayTrigger>
                )}
              </>
            )}
          </div>
        </td>
        {/* <td style={{background:
              name == "Employee Schedule" || name == "Total Hours Allocated"
                ? "rgba(191, 203, 225, 0.6)"
                : "white"}}>25</td> */}
        <td
          className="job-id"
          style={{
            color: hours === "&" ? "transparent" : "#262a44",
            fontSize: "14px",
            fontWeight: "500",
            borderTop: "none",
            borderRight: "none",
            borderBottom: resource?.length == 1 ? "2px solid black" : "",
            background: name === "TOTAL HOURS" ? "#e8ecf0" : "white",
          }}
        >
          {name === "TOTAL HOURS" ? (
            <div
              style={{ fontWeight: "600", color: "#464f60", fontSize: "12px" }}
            >
              TOTAL HOURS
            </div>
          ) : (
            hours
          )}
        </td>
      </>
    );
  };

  const resourceAreaHeaderContent = (arg: any) => {
    return (
      <div
        style={{
          display: "flex",
          gridTemplateColumns: "35% 65%",
          justifyContent: "space-between",
          width: "100%",
          marginTop: "21px",
        }}
      >
        <div style={{ textAlign: "initial", width: "50%" }} className="ml-2">
          ACTIVITY CODE
        </div>
        <div className="mr-2" style={{ textAlign: "initial", width: "50%" }}>
          JOB LIST & CLIENT NAME
        </div>
        {/* <div className="mr-1">Total HRS</div> */}
      </div>
    );
  };

  const { duration, slotDuration, slotLabelFormat } = computeDurations(mode);


  const handleEventContent = (eventInfo: any) => {
    const campaignId = eventInfo?.event?._def?.extendedProps?.campaignId;
    const name = eventInfo?.event?._def?.extendedProps?.name;

    const isTotalRow = campaignId === 0;
    const hasValue = name !== "" && name !== 0;

    if (
      selectedEvent &&
      selectedEvent?._def?.extendedProps?.campaignId === campaignId
    ) {
      return <div></div>;
    }

    // Always render for total row, even if blank
    if (isTotalRow || hasValue) {
      return (
        <div
          style={{
            height: "61.5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "15px",
            fontWeight: 500,
            width: "100%",
            margin: "auto",
          }}
        >
          <span
            style={{
              width: "100%",
              height: "61.5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: isTotalRow
                ? "#e8ecf0" // Light grey background even if name is blank
                : +name < 12
                ? "#e7f0d4"
                : "#faedd8",
              color: isTotalRow
                ? "#262a44"
                : +name >= 12
                ? "#ac6602"
                : "#5a7d0e",
            }}
          >
            {hasValue ? name : null}
          </span>
        </div>
      );
    }

    return <div></div>;
  };

  const handleEventResize = (info: any) => {
    const target = info.jsEvent.target;
    if (
      target.classList.contains("fc-resource-timeline-divider") ||
      target.classList.contains("fc-cell-shaded")
    ) {
      info.revert(); // Revert the resize
    }
  };

  return (
    <>
      <div className="time-sheet">
        <FullCalendar
          ref={calendarRef}
          plugins={[resourceTimelinePlugin, dayGridPlugin]}
          initialView={"resourceTimeline"}
          initialDate={startDate}
          // resourcesInitiallyExpanded={false}
          // eventDurationEditable={false}
          resourceAreaWidth="35%"
          eventResize={handleEventResize} // Handle event resize
          resourceOrder="from"
          headerToolbar={{
            left: "",
            center: "",
            right: "",
          }}
          height={"90vh"}
          // aspectRatio={"auto"}
          resourceAreaHeaderContent={resourceAreaHeaderContent}
          // eventResizable={false}
          slotDuration={slotDuration}
          slotLabelFormat={slotLabelFormat}
          duration={duration}
          resourceLabelContent={CampaignResource}
          resources={resources}
          events={finalReport} //box events
          slotMinWidth={60}
          views={{
            resourceTimelineDay: {
              slowMinWidth: 50,
            },
          }}
          eventClick={(arg: any) => arg.jsEvent.preventDefault()} // Prevent default eventClick behavior
          eventContent={handleEventContent}
        />
      </div>
    </>
  );
};

export default TimeSheetCalender;
